export default __webpack_public_path__ + "static/woman-on-phone-1be03ea41936cdc149ec72350429a4f5.webp";